import React, { useContext } from 'react';
import S from "./RiskAnalysis";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index";
import moment from 'moment';

const RiskAnalysis: React.FC<FundSingle> = () => {
    const { fundRiskDetails } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;
    
    var riskStatistics = fundRiskDetails.RiskStatistics.find((item: any) => item.ReturnType == 'Nav');
    var riskStatsDate = moment(riskStatistics.Date).format('YYYY-MM-DD');
    
    const getValuesFromTimeSeries = (timeSeries: any) => {
        if (!Array.isArray(timeSeries)) return ['-', '-', '-'];

        const getValue = (period: string) => {
            const item = timeSeries.find((item: any) => item?.TimePeriod === period);

            // Check if item is defined and has a Value property. If not, check if it has Count property. If not, return '-'
            if (!item) return '-';
            if (item.Value !== undefined) {
                return (item && typeof item.Value === 'number') ? item.Value.toFixed(2) : '-';
            }
            if (item.Count !== undefined) {
                return (item && typeof item.Count === 'number') ? item.Count : '-';
            }
            return '-';
        };

        return [getValue('M12'), getValue('M36'), getValue('M60')];
    };


    var tableValues = {
        "Snittavkastning": getValuesFromTimeSeries(fundRiskDetails.TrailingPerformance[0].Return),
        "Sharpe-kvot": getValuesFromTimeSeries(riskStatistics.SharpeRatios),
        "Sortino-kvot (10%)": getValuesFromTimeSeries(riskStatistics.SortinoRatios),
        "Positiva månader": getValuesFromTimeSeries(riskStatistics.NumberOfPositives),
        "Negativa månader": getValuesFromTimeSeries(riskStatistics.NumberOfNegatives),
        "Sämsta månad": getValuesFromTimeSeries(riskStatistics.MinimumReturns),
        "Volatilitet": getValuesFromTimeSeries(riskStatistics.StandardDeviations),
    }
    
    var tableData = {
        headings: ['RISKMÅTT', '1 ÅR', '3 ÅR', '5 ÅR'],
        rows: tableValues
    }

    return (
        <S.AllocationWrapper>
            <CardHeader title="Avkastnings-/riskanalys" subTitle={riskStatsDate} />
            <Table tableData={tableData} />
        </S.AllocationWrapper>
    );
};

export default RiskAnalysis;
